{
  "version": 1,
  "asset_id": "9b311c28-7cd4-4924-b55e-95caa2920154",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/9b311c28-7cd4-4924-b55e-95caa2920154/hernando-galvalume-metal-roof-aerial-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/9b311c28-7cd4-4924-b55e-95caa2920154/hernando-galvalume-metal-roof-aerial-1200w.webp",
  "original_filename": "hernando-galvalume-metal-roof-aerial-1200w.webp",
  "size": 137446,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
